var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    attrs: {
      items: _vm.items,
      "item-text": "Name",
      placeholder: "Okul Seçiniz",
      "item-value": "TenantId",
      outlined: "",
      "hide-details": "",
    },
    on: { change: _vm.updateTenant },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }